import { type FC } from 'react';

import { SingleCategoryTypeahead } from '../typeahead/CategoryTypeahead';

import { type EventCategoryDropdownCategoryFragment } from './__generated-gql-types__/EventCategoryDropdown.generated';
import {
  ALL_CATEGORIES_OPTION,
  EventCategoryChangeEvent,
  useChangeCategory,
} from './utils';

interface EventCategoryDropdownProps {
  category: Possible<EventCategoryDropdownCategoryFragment>;
}

export const EventCategoryDropdown: FC<EventCategoryDropdownProps> = ({
  category,
}) => {
  const onChange = useChangeCategory({ handleNavigation: true });

  return (
    <SingleCategoryTypeahead
      label=""
      value={category ?? null}
      onChange={(value) => {
        if (value) {
          void onChange(value, EventCategoryChangeEvent.Dropdown);
        }
      }}
      popularEventsOnly
      initialOptions={category ? [ALL_CATEGORIES_OPTION] : undefined}
      defaultOption={!category ? ALL_CATEGORIES_OPTION : undefined}
    />
  );
};
